module.exports = __webpack_public_path__ + "static/media/report.0a3d119f.svg";